import {
  // @ts-expect-error Using experimental features
  // eslint-disable-next-line @wordpress/no-unsafe-wp-apis
  __experimentalToolsPanel as ToolsPanel,
  __experimentalToolsPanelItem as ToolsPanelItem,
  ToggleControl,
} from "@wordpress/components";
import { InspectorControls } from "@wordpress/block-editor";
import { __ } from "@wordpress/i18n";


export default function Settings({ attributes, setAttributes }) {
  const { displayType } = attributes;

  const manageChartsUrl = `${window.brandyBlocks.url.site}/wp-admin/options-general.php?page=brandy-blocks-settings`;

  return (
    <InspectorControls>
      <ToolsPanel label={__("Settings", "brandy-blocks")}>
        <div>
          <a href={manageChartsUrl} target="_blank">
            Manage charts
          </a>
        </div>
        <ToolsPanelItem
          label={__("Display as popup", "brandy-blocks")}
          hasValue={() => displayType !== "table"}
          isShownByDefault
          onDeselect={() => {
            setAttributes({ displayType: "table" });
          }}
        >
          <ToggleControl
            label={__("Display as popup", "brandy-blocks")}
            checked={displayType === "popup"}
            onChange={(value) => {
              setAttributes({ displayType: value ? "popup" : "table" });
            }}
            help={__(
              "Show size chart in a popup modal when button is clicked",
              "brandy-blocks"
            )}
          />
        </ToolsPanelItem>
      </ToolsPanel>
    </InspectorControls>
  );
}
